/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Fragment as _, useContext } from 'react';
import { interactionContext } from './interactionContext';

const ContinueButtonBranching = props => {
  const context = useContext(interactionContext) as any;

  const { passed } = context;
  const { enableBranching, correctColor, incorrectColor } = context.props;

  const { children } = props;
  const [defaultBtn, passedBtn, failedBtn] = children;

  if (!enableBranching) {
    return defaultBtn;
  }

  const branchingBtn =
    passed === true || passed === undefined ? passedBtn : failedBtn;

  let Btn = branchingBtn;

  if (window.dev && window.dev()) {
    Btn = (
      <div
        css={css({
          '*': {
            boxShadow: 'none !important',
          },

          boxShadow: `0 0 0 1px ${passed ? correctColor : incorrectColor}`,
        })}
      >
        {branchingBtn}
      </div>
    );
  }

  return Btn;
};

export default ContinueButtonBranching;
